<!-- =========================================================================================
  File Name: ServerMonitoringEmilaSidebar.vue
  Description: Add email , Update email, Delete email - Sidebar component
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? $t("ADD_NOTICE") : $t("UPDATE_NOTICE") }} </h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">
      <div class="p-6">
        <template>
          <!-- TITLE -->
          <vs-input  :label="$t('NOTICE_TITLE')" key="notice-title" v-model="noticeTitle" class="mt-5 w-full" name="noticeTitle" v-validate="{ max:10, required: true }" maxlength="11" icon-pack="feather" icon="icon-alert-triangle" icon-no-border  />
          <span class="text-danger text-sm" v-show="errors.has('noticeTitle')">{{ errors.first('noticeTitle') }}</span>
          <br/>
          <!-- BODY -->
          <small>{{$t("NOTICE_BODY")}}</small>
          <vs-textarea id="notice-body" v-model="noticeBody" :counter-danger.sync="counterDanger" counter="200"  name="noticBody"  v-validate="{ max:200, required: true }" />
           <span class="text-danger text-sm" v-show="errors.has('noticBody')">{{ errors.first('noticBody') }}</span>
          <!-- POP UP -->
          <div  v-if="Object.entries(this.data).length !== 0">
            <small>{{$t("POP_UP")}}</small>
            <ul class="demo-alignment">
              <li>
                  <vs-checkbox icon-pack="feather" icon="icon-check" color="success" v-model="popup_Check_Y">{{$t('POPUP_Y')}}</vs-checkbox>
              </li>
              <li>
                  <vs-checkbox icon-pack="feather" icon="icon-x" color="danger" v-model="popup_Check_N">{{$t('POPUP_N')}}</vs-checkbox>
              </li>
            </ul>
          </div>
        </template>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-5" @click="checkSubmit('Submit')" :disabled="!isFormValid">{{$t('SUBMIT')}}</vs-button>
      <vs-button  class="mr-10" type="border" color="danger" @click="isSidebarActiveLocal = false">{{$t('CLOSE')}}</vs-button>
    </div>

  </vs-sidebar>
</template>

<script>
let sanitizeHtml = require('sanitize-html');

import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'

export default {
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
  },
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {},
    }
  },
  mounted() {
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.popUp = "N"
        this.$validator.reset()
        this.isRequiredForNew = true
        this.isRequiredForUpdate = false
      } else {
        this.isRequiredForNew = false
        this.initValues()
        let { seq, popUp, noticeTitle, noticeBody } = JSON.parse(JSON.stringify(this.data))
        this.seq = seq
        this.popUp = popUp
        this.noticeTitle = noticeTitle
        this.noticeBody = noticeBody
        this.$validator.reset()
      }
    },
    popUp(val){
      if(val === "Y"){
        this.popup_Check_Y = true
        this.popup_Check_N = false
      } else {
        this.popup_Check_Y = false
        this.popup_Check_N = true
      }
    },
    popup_Check_Y(val){
      if(val){
        this.popUp = "Y"
      }else{
        if(!this.popup_Check_N){
          this.popUp = "N"
        }
      }
    },
    popup_Check_N(val){
      if(val){
        this.popUp = "N"
      }else{
        if(!this.popup_Check_Y){
          this.popUp = "Y"
        }
      }
    }
  },
  data() {
    return {

      popUp: "", 
      noticeTitle: "", 
      noticeBody: "",

      popup_Check_Y: false,
      popup_Check_N: false,

      isRequiredForNew: false,
      isRequiredForUpdate: false,

      counterDanger:false,

      settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
      },
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if(!val) {
          this.$emit('closeSidebar')
        }
      }
    },
    isFormValid() {
        return !this.errors.any()
    },
  },
  methods: {
    initValues() {
      if(this.data.id) return
      this.seq  = ""
      this.popUp = ""
      this.noticeTitle = ""
      this.noticeBody = ""
    },
    async checkSubmit(action){
      this.$vs.loading()
      const popUpY = await this.checkPopUpY()

      this.$validator.validateAll().then(result => {
        if (result) {
          if((this.popUp === "Y") && (popUpY > 0)){
            this.rejectConfirm()
          } else {
            this.openConfirm(action)
          }
        }
      })
      .catch((error)=>{
          this.errorAlert(this.$t("ERROR"), error.message)
      })
    },
    checkPopUpY(){
      if(this.seq==""){
        this.seq = 0
      }
      return new Promise( (resolve, reject) => {
          this.$store.dispatch("dataSystem/getPopupYNotice",this.seq)              
          .then((result) => {
            return resolve(result.data.resultCount)
          })
          .catch(error => {
            this.errorAlert(this.$t("ERROR"), error.message)
          })
      })
    },
    submitData() {
        this.$vs.loading()

        const obj = {
            seq : this.seq,
            popUp : this.popUp,
            noticeTitle : sanitizeHtml(this.noticeTitle),
            noticeBody : sanitizeHtml(this.noticeBody)
        }

        if (!this.seq) {
          this.$store.dispatch("dataSystem/addNotice", obj)              
          .then(() => {
            this.formClear(this.$t('ADD_NOTICE_SUCCESS'))
          })
          .catch(error => {
            if(error === "DUPLICATE_EMAIL_ERROR"){
              this.errorAlert(this.$t("FAIL"), this.$t(error))
            }else{
              this.errorAlert(this.$t("ERROR"), error.message)
            }
            this.$vs.loading.close()
          })
        } else {
          this.$store.dispatch("dataSystem/updateNotice", obj)
          .then(() => {
            this.formClear(this.$t('UPDATE_NOTICE_SUCCESS'))
          })
          .catch(error => { 
            if(error === "DUPLICATE_EMAIL_ERROR"){
              this.errorAlert(this.$t("FAIL"), this.$t(error))
            }else{
              this.errorAlert(this.$t("ERROR"), error.message)
            }
            this.$vs.loading.close()
          })
        } 
    },
    formClear(submitMessage){
        this.$vs.loading.close()
        this.$emit('closeSidebar')
        this.initValues() 
        this.successAlert(this.$t("SUCCESS"),submitMessage)
        this.$parent.$refs.noticeTable.getData()
    },
    openConfirm(action) {
      this.$vs.loading.close()
      let textMessage = ""
      let acceptAction =""

      if (this.popUp === "Y") {
        textMessage = this.$t('SUBMIT_NOTICE_MESSAGE')
        acceptAction = this.submitData
      } else {
        textMessage = this.$t('SUBMIT_CONFIRM_MESSAGE')
        acceptAction = this.submitData
      }

      this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: this.$t('CONFIRM'),
          text: textMessage,
          accept: acceptAction,
          acceptText: this.$t('CONFIRM'),
          cancelText: this.$t('CANCEL')
      })
    },
    rejectConfirm() {
      this.$vs.loading.close()
      let textMessage = ""

      textMessage = this.$t('REJECT_CONFIRM_MESSAGE')

      this.$vs.dialog({
          color: 'danger',
          title: this.$t('REJECT'),
          text: textMessage,
          acceptText: this.$t('OK'),
      })
    },
    getLabel(option) {
      return this.$t([option.text])
    },
  },
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52004;
  }

  ::v-deep .vs-sidebar {
    z-index: 52004;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
}


</style>

<style lang="scss">
#notice-body{
  height: 200px !important;
}
</style>

